import { Box, Icon, IconButton, Logo } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';
import { SambaAutoLink } from '@betterment/shared-components';

import { useSidebarMode } from '../../../sidebar/hooks/useSidebarMode';
import { urlBuilder } from '../../urlBuilder';

export interface NavHeaderProps {
  hasLogo: boolean;
  onHamburgerClick: () => void;
}

const className = css({
  alignItems: 'baseline',
  display: 'grid',
  width: '100%',
  gridTemplateColumns: 'auto 1fr auto',
  position: 'fixed',
  top: 0,
  height: '56px',
  backgroundColor: 'background.surface',
  color: 'primitives.black',
});

export default function NavHeader(props: NavHeaderProps) {
  const { hasLogo, onHamburgerClick } = props;
  const [sidebarMode] = useSidebarMode();

  return (
    <header className={className}>
      <IconButton
        css={{
          cursor: 'pointer',
          backgroundColor: 'transparent',
          color: 'icon',
          padding: 'space.200',
          margin: 0,
        }}
        onClick={onHamburgerClick}
        label="Open navigation menu"
        name="Hamburger"
        aria-controls="navigation-sidebar"
        aria-expanded={sidebarMode === 'expanded'}
      />
      {hasLogo && (
        <Box asChild={true} css={{ display: 'grid' }}>
          <SambaAutoLink to={urlBuilder.appHome.absolute()}>
            <Logo aria-label="Betterment" type="symbol" css={{ height: 'icon.small' }} />
          </SambaAutoLink>
        </Box>
      )}
      <SambaAutoLink
        css={{ color: 'icon', padding: 'space.200', gridColumnStart: 3 }}
        to={urlBuilder.appTransfersNewTransfer.absolute()}
      >
        <Icon aria-label="New transfer" name="Transfer" size="small" />
      </SambaAutoLink>
    </header>
  );
}
